<template>
  <div class="usersettings">
    <!-- Профиль пользователя -->
    <div class="usersettings-section" v-show="user.menu === 0">
      <div class="options-panel_head">
        <div class="s-title text-green" >
          Профиль пользователя
        </div>
      </div>
      <div class="style-hr__solid">
      </div>
      <perfect-scrollbar style="max-height: 100%">
        <div class="usersettings-content usersettings__stock" v-if="user.data">
          <div class="usersettings-col">
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Фамилия
              </div>
              <div class="usersettings_form-field">
                <input type="text" placeholder="Иванов" v-model="user.data.last_name">
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Имя
              </div>
              <div class="usersettings_form-field">
                <input type="text" placeholder="Иван" v-model="user.data.first_name">
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Отчество
              </div>
              <div class="usersettings_form-field">
                <input type="text" placeholder="Иванович" v-model="user.data.patronymic">
              </div>
            </div>

            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Дата рождения
              </div>
              <div class="usersettings_form-field">
                <input type="text" placeholder=""
                       v-model="user.data.birth_date"
                       v-on:focus="openDatapickerBirthdate"
                       v-on:blur="closeDatapickerBirthdate">
                <div class="form-control_datepicker" v-show="datepicker.birthDate.show">
                  <datepicker
                      ref="datepickerBirthDate"
                      v-model="datepicker.birthDate.value"
                      :language="datepicker.birthDate.lang.ru"
                      :input-class="datepicker.birthDate.inputClass"
                      :monday-first="true"
                      @selected="datepickerFormatterBirthDate"
                      :inline="true">
                  </datepicker>
                </div>
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Номер для связи
              </div>
              <div class="usersettings_form-field">
                <!--<masked-input v-model="user.data.phone" mask="\+1\ 111 111-11-11" placeholder="+7 XXX XXX-XX-XX">
                </masked-input>-->
								<input v-model="user.data.phone" placeholder="+1 1111111111" class="notification_new-phone" autocomplete="new-password">
								<!--  autocomplete="new-password" - фикс бага в FF -->
              </div>
            </div>

            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Часовая зона:
              </div>
              <div class="usersettings_form-field usersettings-timezone">
                <cool-select v-model="timeZone"
                             :items="user.data.time_zone.list"
                             item-value="value"
                             item-text="text"
                             :placeholder="timeZone"
                             :disableSearch="true"
                             menuItemsMaxHeight="160px">
                </cool-select>
              </div>
            </div>
            <div class="usersettings_form-control text-right">
              <div class="usersettings_form-field">
                <button class="btn btn-success" v-on:click="saveUserData">Сохранить</button>
              </div>
            </div>
          </div>
          <div class="usersettings_separator">
          </div>
          <div class="usersettings-col">
            <div class="usersettings_subtitle">
              <span class="text-color-base-b2">Смена пароля</span>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Старый пароль
              </div>
              <div class="usersettings_form-field">
                <input type="password" placeholder="Пароль" v-model="password.old_password">
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Новый пароль
              </div>
              <div class="usersettings_form-field">
                <input type="password" placeholder="Пароль" v-model="password.new_password1">
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Повторите пароль
              </div>
              <div class="usersettings_form-field">
                <input type="password" placeholder="Пароль" v-model="password.new_password2">
              </div>
            </div>
            <div class="usersettings_form-control text-right">
              <div class="usersettings_form-field usersettings_form-field__none-brd">
                <button class="btn btn-success" v-on:click="changePassword()">Сохранить</button>
              </div>
            </div>
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                <div class="text-color-base-b2">Удаление учетной записи</div>
                <br>
                При удалении аккаунта будут также удалены все связанные с ним системы. Для возобновления работы потребуется новая регистрация.
              </div>
              <div class="usersettings_form-field usersettings_form-field__none-brd text-right">
                <button class="btn btn-cancel" v-on:click="showPopup()">Удалить аккаунт</button>
              </div>
            </div>
            <div v-if="!user.data.is_verified">
              <div class="settings-operation settings-operation__warning">
                Для дальнейшей корректной работы с системой Вам необходимо подтвердить свой e-mail
              </div>
              <div class="usersettings_form-name">
                <button class="btn btn-warning" v-on:click="sendConfirm()">Отправить письмо для подтверждения</button>
              </div>
            </div>
						<div class="usersettings_form-control usersettings-logout">
							<div class="usersettings_form-field">
								<button class="btn btn-cancel" v-on:click="logout()">Выйти из аккаунта</button>
							</div>
						</div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <!-- Менеджер автопарка -->
    <div class="usersettings-section"
				 v-if="user.menu === 1"
				 v-on:mousedown="checkOpenPalette($event, palette.show)">
      <div class="options-panel_head">
        <div class="s-title text-green" >
          Менеджер автопарка
        </div>
      </div>
      <div class="style-hr__solid">
      </div>
      <perfect-scrollbar style="max-height: 100%">
        <div class="usersettings-content">
          <div class="usersettings-col">
            <div class="settings-operation">
              <button class="btn btn-clean btn-brd" v-on:click="editRegistration()">
                Регистрация нового автомобиля
              </button>
            </div>
            <!-- start Мои авто -->
            <div>
              <div class="usersettings_subtitle">
                <span class="text-color-base-b2">Мои автомобили</span>
              </div>
              <div class="usersettings_car-list">
                <div class="usersettings_car-item"
                     v-for="(carOwner, carOwnerIndex) in listCar"
                     v-bind:key="carOwnerIndex"
                     v-bind:class="{ 'usersettings_car-item__active' : carOwnerIndex === activeCar }"
                     v-if="carOwner.role === 1"
                     v-on:click="editOwner(carOwnerIndex)">
                  <div class="usersettings_car-photo">
                    <div class="new-photo_image"
                         v-if="carOwner.photo !== ''"
                         v-bind:style="{ 'background-image' : 'url(' + carOwner.photo + ')' }">
                    </div>
                  </div>
                  <div class="list-cars_name-car m-title">
                    <span v-if="carOwner.name">{{carOwner.name}}</span>
                    <span v-else>Новое авто</span>
                  </div>
                  <div class="list-cars_reg-id">
                    <span v-if="carOwner.registration_id">{{carOwner.registration_id}}</span>
                    <span v-else>- _ _ _ -- _ _ _ --</span>
                  </div>
                </div>
                <div class="usersettings_car-empty">
                  <div class="usersettings_form-name text-base">
                    Автомобили отсутствуют
                  </div>
                </div>
              </div>
            </div>
            <!-- start Расшаренные авто -->
            <div>
              <div class="usersettings_subtitle">
                <span class="text-color-base-b2">Переданные автомобили:</span>
              </div>
              <div class="usersettings_car-list">
                <div class="usersettings_car-item"
                     v-for="(carShare, carShareIndex) in listCar"
                     v-bind:key="carShareIndex"
                     v-bind:class="{ 'usersettings_car-item__active' : carShareIndex === activeCar }"
                     v-if="carShare.role !== 1"
                     v-on:click="editShare( carShareIndex )">
                  <div class="usersettings_car-photo">
                    <div class="new-photo_image"
                         v-if="carShare.photo !== ''"
                         v-bind:style="{ 'background-image' : 'url(' + carShare.photo + ')' }">
                    </div>
                  </div>
                  <div class="list-cars_name-car m-title">
                    {{carShare.name}}
                  </div>
                  <div class="list-cars_reg-id">
                    {{carShare.registration_id}}
                  </div>
                </div>
                <div class="usersettings_car-empty">
                  <div class="usersettings_form-name text-base">
                    Автомобили отсутствуют
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="usersettings_separator">
          </div>
          <div class="usersettings-col">
            <!-- start Редактирование деталей авто Owner -->
            <div v-if="manageStatus === 1">
              <div class="new-photo">
                <label class="new-photo_dropzone">
                  <div class="new-photo_image"
                       v-if="edit.owner.img !== ''"
                       v-bind:style="{ 'background-image' : 'url(' + edit.owner.img + ')' }">
										<img crossorigin="anonymous" v-bind:src="edit.owner.img" ref="ownImg" style="display: none">
                  </div>
                  <div class="new-photo_icon">
                    <img src="../../assets/img/menu/addphoto.svg" >
                  </div>
                  <input type="file" ref="photo" class="new-photo_field"
                         v-on:change="uploadImg()"/>
                </label>
              </div>
							<div class="usersettings_form-control">
								<div class="usersettings_subtitle">
									<span class="">Цвет автомобиля</span>
								</div>
								<div class="palette">
									<div class="palette-choose">
										<div class="palette-choose_icon" v-on:click="palette.show = true">
										</div>
										<div class="palette-choose_field"
												 id="paletteField"
												 v-show="palette.show">
											<chrome v-model="palette.colors" ref="chrome">
											</chrome>
										</div>
									</div>
									<span class="palette-item active"
												v-on:click="palette.show = true"
												v-bind:style="{ backgroundColor : palette.colors.hex8 }">
									</span>
									<div class="palette_cnt">
										<span class="palette-item"
													v-for="color in edit.owner.palette"
													v-on:click="changeColorPalette( color )"
													v-bind:style="{ backgroundColor : color }"></span>
									</div>
								</div>
							</div>
							<div class="usersettings_form-control">
								<div class="usersettings_subtitle">
									<span class="">Кузов автомобиля</span>
								</div>
								<div class="usersettings-bodycar">
									<div class="usersettings-bodycar_item"
											 v-bind:style="{ backgroundImage : 'url(' + require('../../assets/img/kuzov/kuzov' + index + '.svg') + ')' }"
											 v-bind:class="{ 'active' : listCar[ activeCar ].body_style === index-1 }"
											 v-on:click="listCar[ activeCar ].body_style = index-1"
											 v-for="index in 5">
									</div>
                  <div class="usersettings-bodycar_item"
                       v-bind:style="{ backgroundImage : 'url(' + require('../../assets/img/kuzov/kuzov10.svg') + ')' }"
                       v-bind:class="{ 'active' : listCar[ activeCar ].body_style === 10 }"
                       v-on:click="listCar[ activeCar ].body_style = 10">
                  </div>
								</div>
							</div>
							<div class="usersettings_form-control">
								<div class="usersettings_form-name">
									Серийный номер
								</div>
								<div class="usersettings_form-field">
									<input type="text" placeholder="Введите имя" disabled="disabled" v-model="listCar[activeCar].device.serial">
								</div>
							</div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Имя автомобиля
                </div>
								<div class="usersettings_form-field">
									<input type="text" placeholder="Введите имя" v-model="edit.owner.name">
								</div>
              </div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Гос. регистрационный номер
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Введите номер" v-model="edit.owner.registration_id">
                </div>
              </div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Номер свидетельства о регистрации(СТС)
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Введите номер" v-model="edit.owner.registration_certificate_id">
                </div>
              </div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  VIN номер
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Введите номер"
												 v-model="listCar[activeCar].vin"
												 v-bind:disabled="!listCar[activeCar].is_vin_editable">
                </div>
              </div>

							<div class="usersettings_form-control usersettings_form-control__no-brd">
								<div class="usersettings_form-name">
									Тип топлива
								</div>
								<div class="usersettings_form-field">
									<v-select :options="fuelType"
														v-model="listCar[activeCar].fuelType"
														:searchable="false"
														:clearable="false"
														label="name">
									</v-select>
								</div>
							</div>
							<div class="usersettings_form-control">
								<div class="usersettings_form-name">
									Объем топливного бака(л)
								</div>
								<div class="usersettings_form-field">
									<input type="text" placeholder="Введите номер"
												 v-model="listCar[activeCar].fuel_tank_capacity"
												 maxlength="3"
												 @keypress="isNumber($event)">
								</div>
							</div>

              <div class="usersettings_form-control usersettings_form-control__end text-right">
                <div class="usersettings_form-field">
                  <button class="btn btn-success" v-on:click="saveOwnerCar()">Сохранить</button>
                </div>
              </div>
              <div class="usersettings_form-warning">
                <div class="usersettings_form-warning-description"
                     v-bind:class="{ 'active' : delCarType === 1 }"
                     v-on:click="delCarType = 1">
                  <i class="usersettings_form-warning-radio"></i>
                  <b>Удаление охранного устройства</b> из вашего аккаунта позволит передать
                  автомобиль другому владельцу и сохранить у вас журнал событий и историю поездок.
                </div>
                <div class="usersettings_form-warning-description"
                     v-bind:class="{ 'active' : delCarType === 2 }"
                     v-on:click="delCarType = 2">
                  <i class="usersettings_form-warning-radio"></i>
                  <b>Удалив автомобиль</b>, вы удалите информацию об охранном устройстве,
                  истории поездок, и журнале событий со своего аккаунта.
                </div>
                <button class="btn btn-warning__dark btn-del"
                        v-if="delCarType === 1"
                        v-on:click="delCar()">
                  Отвязать автомобиль
                </button>
                <button class="btn btn-warning__dark btn-del"
                        v-bind:disabled="delCarType === 0"
                        v-else
                        v-on:click="delCar()">
                  Удалить автомобиль
                </button>
              </div>
            </div>
            <!-- start Редактирование деталей авто Share -->
            <div v-if="manageStatus === 2">
							<div class="usersettings_form-control" v-if="listCar[activeCar].device.serial">
								<div class="usersettings_form-name">
									Серийный номер
								</div>
								<div class="usersettings_form-field">
									<input type="text" placeholder="Введите имя" disabled="disabled" v-model="listCar[activeCar].device.serial">
								</div>
							</div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Имя автомобиля
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Введите имя" v-model="edit.share.name">
                </div>
              </div>
              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Имя водителя
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Введите имя" v-model="edit.share.owner.name">
                </div>
              </div>
              <div class="usersettings_form-control text-right usersettings_form-control__end">
                <div class="usersettings_form-field">
                  <button class="btn btn-success" v-on:click="saveShareCar()">Сохранить</button>
                </div>
              </div>

              <div class="usersettings_form-warning">
                Удаление данного автомобиля из <b>вашего аккаунта</b>
                <br><br>
                <button class="btn btn-warning__dark btn-del"
                        v-on:click="delShare(listCar[activeCar].id, listCar[activeCar].share_id)">
                  Удалить автомобиль
                </button>
              </div>
            </div>
            <!-- start Новое авто -->
            <div v-if="manageStatus === 3">

              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Выберите охранную систему
                </div>
                <div class="usersettings_form-radio"
                     v-on:click="typeRegDevice = 1"
                     v-bind:class="{ 'active' : typeRegDevice === 1 }">
                  <i class="usersettings_form-radio-btn"></i>
                  Scher-Khan Universe
                </div>
                <div class="usersettings_form-radio"
                     v-on:click="typeRegDevice = 2"
                     v-bind:class="{ 'active' : typeRegDevice === 2 }">
                  <i class="usersettings_form-radio-btn"></i>
                  Scher-Khan X/Mobicar 3/3L/M30/M40
                </div>
              </div>

              <div v-if="typeRegDevice === 1">
                <div class="usersettings_form-control">
                  <div class="usersettings_form-name">
                    Серийный номер
                  </div>
                  <div class="usersettings_form-description">
                    Введите последние 10 цифр серийного номера устройства с гарантийного талона
                  </div>
                  <div class="usersettings_form-img">
                    <img src="../../assets/img/warranty_card.jpg">
                  </div>
                  <div class="usersettings_form-field">
                    <input type="text" placeholder="0000000000" maxlength="10" v-model="edit.newCar.serial">
                  </div>
                </div>
                <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Ключ регистрации
                </div>
                <div class="usersettings_form-description">
                  Введите 11 символов KEY сс карты активации
                </div>
                <div class="usersettings_form-img">
                  <img src="../../assets/img/garanty_card.jpg"/>
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="XXXXXXXXXXX" maxlength="11" v-model="edit.newCar.regkey">
                </div>
              </div>
              </div>

              <div v-if="typeRegDevice === 2">
                <div class="usersettings_form-control">
                  <div class="usersettings_form-name">
                    Серийный номер
                  </div>
                  <div class="usersettings_form-description">
                    Введите последние 10 цифр серийного номера устройства с гарантийного талона
                  </div>
                  <div class="usersettings_form-img">
                    <img src="../../assets/img/warranty_card2.jpg">
                  </div>
                  <div class="usersettings_form-field">
                    <input type="text" placeholder="0000000000" maxlength="10" v-model="edit.newCar.serial">
                  </div>
                </div>
                <div class="usersettings_form-control">
                  <div class="usersettings_form-name">
                    Ключ регистрации
                  </div>
                  <div class="usersettings_form-description">
                    Введите 11 символов KEY сс карты активации
                  </div>
                  <div class="usersettings_form-img">
                    <img src="../../assets/img/garanty_card2.jpg"/>
                  </div>
                  <div class="usersettings_form-field">
                    <input type="text" placeholder="XXXXXXXXXXX" maxlength="11" v-model="edit.newCar.regkey">
                  </div>
                </div>
              </div>

              <div class="usersettings_form-control text-right">
                <div class="usersettings_form-field">
                  <button class="btn btn-success" v-on:click="saveNewCar()">Сохранить</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <!-- Настройки оповещения о ТО -->
    <div class="usersettings-section" v-if="user.menu === 2">
      <div class="options-panel_head">
        <div class="s-title text-green" >
          Настройки оповещения о ТО
        </div>
      </div>
      <div class="style-hr__solid">
      </div>
      <perfect-scrollbar style="max-height: 100%">
        <div class="usersettings-content">
          <div class="usersettings-col">
            <!-- start Мои авто -->
            <div>
              <div class="usersettings_subtitle">
                <span class="text-color-base-b2">Мои автомобили:</span>
              </div>
              <div class="usersettings_car-list">
                <div class="usersettings_car-item"
                     v-for="(carOwner, carOwnerIndex) in listCar"
                     v-bind:key="carOwnerIndex"
                     v-bind:class="{ 'usersettings_car-item__active' : carOwnerIndex === notifTO.index }"
                     v-on:click="selectCarNotifTO(carOwnerIndex)"
                     v-if="carOwner.role === 1">
                  <div class="usersettings_car-photo">
                    <div class="new-photo_image"
                         v-if="carOwner.photo !== ''"
                         v-bind:style="{ 'background-image' : 'url(' + carOwner.photo + ')' }">
                    </div>
                  </div>
                  <div class="list-cars_name-car m-title">
                    <span v-if="carOwner.name">{{carOwner.name}}</span>
                    <span v-else>Новое авто</span>
                  </div>
                  <div class="list-cars_reg-id">
                    <span v-if="carOwner.registration_id">{{carOwner.registration_id}}</span>
                    <span v-else>- _ _ _ -- _ _ _ --</span>
                  </div>
                  <div class="notifTO-info">
                    <div v-if="notifTO.relevance[carOwner.id]">
                      <div class="notifTO-info_type"
                          v-if="notifTO.relevance[carOwner.id].dt_threshold">
                        {{notifTO.relevance[carOwner.id].dt_threshold}}
                      </div>
                      <div class="notifTO-info_type"
                          v-if="notifTO.relevance[carOwner.id].odometer_threshold">
                        {{notifTO.relevance[carOwner.id].odometer_threshold}}
                      </div>
                      <div v-if="notifTO.relevance[carOwner.id].is_sent"
                           class="notifTO-info_status text-color-accent">
                        Выполнено
                      </div>
                      <div class="notifTO-info_status text-color-base-b2"
                          v-if="!notifTO.relevance[carOwner.id].is_sent">
                        Запланировано
                      </div>
                    </div>
                  </div>
                </div>
                <div class="usersettings_car-empty">
                  <div class="usersettings_form-name text-base">
                    Автомобили отсутствуют
                  </div>
                </div>
              </div>
            </div>
            <!-- start Расшаренные авто -->
            <div>
              <div class="usersettings_subtitle">
                <span class="text-color-base-b2">Переданные автомобили:</span>
              </div>
              <div class="usersettings_car-list">
                <div class="usersettings_car-item"
                     v-for="(carShare, carShareIndex) in listCar"
                     v-bind:key="carShareIndex"
                     v-bind:class="{ 'usersettings_car-item__active' : carShareIndex === notifTO.index }"
                     v-on:click="selectCarNotifTO(carShareIndex)"
                     v-if="carShare.role !== 1">
                  <div class="usersettings_car-photo">
                    <div class="new-photo_image"
                         v-if="carShare.photo !== ''"
                         v-bind:style="{ 'background-image' : 'url(' + carShare.photo + ')' }">
                    </div>
                  </div>
                  <div class="list-cars_name-car m-title">
                    {{carShare.name}}
                  </div>
                  <div class="list-cars_reg-id">
                    {{carShare.registration_id}}
                  </div>
                  <div class="notifTO-info">
                    <div v-if="notifTO.relevance[carShare.id]">
                      <div class="notifTO-info_type"
                           v-if="notifTO.relevance[carShare.id].dt_threshold">
                        {{notifTO.relevance[carShare.id].dt_threshold | moment("DD.MM.YYYY")}}
                      </div>
                      <div class="notifTO-info_type"
                           v-if="notifTO.relevance[carShare.id].odometer_threshold">
                        {{notifTO.relevance[carShare.id].odometer_threshold}}
                      </div>
                      <div v-if="notifTO.relevance[carShare.id].is_sent"
                           class="notifTO-info_status text-color-accent">
                        Выполнено
                      </div>
                      <div class="notifTO-info_status text-color-base-b2"
                           v-if="!notifTO.relevance[carShare.id].is_sent">
                        Запланировано
                      </div>
                    </div>
                  </div>
                </div>
                <div class="usersettings_car-empty">
                  <div class="usersettings_form-name text-base">
                    Автомобили отсутствуют
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="usersettings_separator">
          </div>
          <div class="usersettings-col"
               v-if="notifTO.index > -1">
            <div class="usersettings_form-control">
              <div class="usersettings_form-name">
                Пробег автомобиля
              </div>
              <div class="usersettings_form-field">
                {{(stateCar[listCar[notifTO.index].id].odometer).toFixed(0)}} км
              </div>
            </div>
            <div class="notifTO">
              <div class="notifTO-title">
                Оповестить
              </div>
              <div class="notifTO-radio">
                <label class="radio-control">
                  <input type="radio" value="val" v-model="notifTO.radio" class="radio-control_field" />
                  <i class="radio-control_icon"></i>
                  при показаниях одометра
                </label>
              </div>
              <div class="usersettings_form-field"
                   v-bind:class="{ 'usersettings_form-field__disabled' : notifTO.radio !== 'val' }">
                <input type="text" v-model="notifTO.odometer">
              </div>
              <div class="style-hr style-hr__solid">
              </div>

              <div class="notifTO-radio">
                <label class="radio-control">
                  <input type="radio" value="date" v-model="notifTO.radio" class="radio-control_field" />
                  <i class="radio-control_icon"></i>
                  по дате
                </label>
              </div>
              <div class="usersettings_form-control__no-brd">
                <div class="usersettings_form-field"
                     v-bind:class="{ 'usersettings_form-field__disabled' : notifTO.radio !== 'date' }">
                  <datepicker
                      ref="datepicker"
                      :language="notifTO.datepicker.lang.ru"
                      :input-class="notifTO.datepicker.inputClass"
                      :disabledDates="notifTO.datepicker.disabledDates"
                      :monday-first="true"
                      :inline="true"
                      v-model="notifTO.datepicker.value">
                  </datepicker>
                </div>
              </div>
              <div class="style-hr style-hr__solid">
              </div>

              <div class="usersettings_form-control">
                <div class="usersettings_form-name">
                  Текст напоминания
                </div>
                <div class="usersettings_form-field">
                  <input type="text" placeholder="Напоминание о ТО" v-model="notifTO.text">
                </div>
              </div>
              <div class="usersettings_form-control text-right">
                <div class="usersettings_form-field">
                  <button class="btn btn-success" v-on:click="saveNotifTO">Сохранить</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <!-- Сервисные отчеты -->
    <div class="usersettings-section" v-if="user.menu === 3">
      <div class="options-panel_head">
        <div class="s-title text-green" >
          Сервисные отчеты
        </div>
      </div>
      <div class="style-hr__solid">
      </div>
      <perfect-scrollbar style="max-height: 100%">
        <div class="usersettings-content">
          <div class="usersettings-col">
            <div class="settings-operation">
              <button class="btn btn-brd"
                      v-bind:class="{ 'btn-clean'   : serviceReport.selectCars.length,
                                      'btn-success' : !serviceReport.selectCars.length }"
                      v-on:click="toggleReportCar()">
                Выбрать автомобили
              </button>
              <div class="settings-operation_description">
                Выбрано {{serviceReport.selectCars.length}} авто
              </div>
            </div>
            <div class="report_menu">
              <div class="report_menu-item"
                   v-bind:class="{ 'report_menu-item__active' : serviceReport.panel === 2 }"
                   v-on:click="changeReportType(2)">
                <div class="report_menu-icon"
                     v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/menu/menu_icon_7_gray.svg') + ')' }">
                </div>
                <div class="report_menu-title">
                  Пробег за период
                </div>
                <div class="report_menu-description">
                  Составление отчета
                </div>
              </div>
              <div class="report_menu-item"
                   v-bind:class="{ 'report_menu-item__active' : serviceReport.panel === 3 }"
                   v-on:click="changeReportType(3)">
                <div class="report_menu-icon"
                     v-bind:style="{ backgroundImage: 'url(' + require('../../assets/img/menu/menu_icon_7_gray.svg') + ')' }">
                </div>
                <div class="report_menu-title">
                  Сводный отчет
                </div>
                <div class="report_menu-description">
                  Составление отчета
                </div>
              </div>
            </div>
          </div>
          <div class="usersettings_separator">
          </div>
          <div class="usersettings-col">
            <div v-if="serviceReport.panel === 1"
                 class="usersettings_car-list">
              <div class="usersettings_car-item"
                   v-for="(car, carIndex) in listCar"
                   v-bind:key="carIndex"
                   v-bind:class="{ 'usersettings_car-item__disable' : !car.access_report,
                                   'usersettings_car-item__check'   : serviceReport.selectCars.indexOf(car.id) !== -1 }"
                   v-on:click="selectReportCar( carIndex )">
                <div class="usersettings_car-photo">
                  <div class="new-photo_image"
                       v-if="car.photo !== ''"
                       v-bind:style="{ 'background-image' : 'url(' + car.photo + ')' }">
                  </div>
                </div>
                <div class="list-cars_name-car m-title">
                  {{car.name}}
                </div>
                <div class="list-cars_reg-id">
                  {{car.registration_id}}
                </div>
              </div>
              <div class="usersettings_car-empty">
                <div class="usersettings_form-name text-base">
                  Автомобили отсутствуют
                </div>
              </div>
            </div>
            <div v-if="serviceReport.panel === 2">
              <div class="report-title">
                Пробег за период
              </div>
              <div class="report-datapicker">
                <datepicker
                    ref="datepicker"
                    :language="serviceReport.datepicker.lang.ru"
                    :input-class="serviceReport.datepicker.inputClass"
                    :disabledDates="serviceReport.datepicker.disabledDates"
                    :highlighted="serviceReport.datepicker.highlighted"
                    :inline="true"
                    :monday-first="true"
                    @selected="selectDateReport"
                    v-model="serviceReport.datepicker.value">
                </datepicker>
              </div>
              <div class="report-time">
                <span class="report-time_title">
                  с
                </span>
                <div class="autostart-time autostart-time__short">
                  <label>
                    <masked-input class="field-time_hour"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-model="serviceReport.time.from.hours"
                                  v-on:keyup.native="changeTime( 'Fhours' )"
                                  v-on:blur.native="blurTimeField('Fhours')">
                    </masked-input>
                    <!--<span>:</span>
                    <masked-input class="field-time_minute"
                                  v-model="serviceReport.time.from.minutes"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-on:keyup.native="changeTime( 'Fminutes' )"
                                  v-on:blur.native="blurTimeField('Fminutes')">
                    </masked-input>-->
                  </label>
                </div>
                <span class="report-time_title">
                  по
                </span>
                <div class="autostart-time autostart-time__short">
                  <label>
                    <masked-input class="field-time_hour"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-model="serviceReport.time.to.hours"
                                  v-on:keyup.native="changeTime( 'Thours' )"
                                  v-on:blur.native="blurTimeField('Thours')">
                    </masked-input>
                    <!--<span>:</span>
                    <masked-input class="field-time_minute"
                                  v-model="serviceReport.time.to.minutes"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-on:keyup.native="changeTime( 'Tminutes' )"
                                  v-on:blur.native="blurTimeField('Tminutes')">
                    </masked-input>-->
                  </label>
                </div>
								<span class="report-time_title">
                  часов
                </span>
              </div>
              <div class="report-files"
                   v-bind:class="{ 'report-files__send' : serviceReport.send }">
                <div class="report-files_item report-files__pdf"
                     v-on:click="downloadFile('pdf')">
                  Скачать Отчет_пробег_за_период.pdf
                </div>
                <div class="report-files_item report-files__xlsx"
                     v-on:click="downloadFile('xlsx')">
                  Скачать Отчет_пробег_за_период.xlsx
                </div>
                <a href="" style="display: none" class="report-pdf"></a>
                <a href="" style="display: none" class="report-xlsx"></a>
              </div>
            </div>
            <div v-if="serviceReport.panel === 3">
              <div class="report-title">
                Пробег за период
              </div>
              <div class="report-datapicker">
                <datepicker
                    ref="datepicker"
                    :language="serviceReport.datepicker.lang.ru"
                    :input-class="serviceReport.datepicker.inputClass"
                    :disabledDates="serviceReport.datepicker.disabledDates"
                    :highlighted="serviceReport.datepicker.highlighted"
                    :inline="true"
                    :monday-first="true"
                    @selected="selectDateReport"
                    v-model="serviceReport.datepicker.value">
                </datepicker>
              </div>
              <div class="report-time">
                <span class="report-time_title">
                  с
                </span>
                <div class="autostart-time autostart-time__short">
                  <label>
                    <masked-input class="field-time_hour"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-model="serviceReport.time.from.hours"
                                  v-on:keyup.native="changeTime( 'Fhours' )"
                                  v-on:blur.native="blurTimeField('Fhours')">
                    </masked-input>
                    <!--<span>:</span>
                    <masked-input class="field-time_minute"
                                  v-model="serviceReport.time.from.minutes"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-on:keyup.native="changeTime( 'Fminutes' )"
                                  v-on:blur.native="blurTimeField('Fminutes')">
                    </masked-input>-->
                  </label>
                </div>
                <span class="report-time_title">
                  по
                </span>
                <div class="autostart-time autostart-time__short">
                  <label>
                    <masked-input class="field-time_hour"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-model="serviceReport.time.to.hours"
                                  v-on:keyup.native="changeTime( 'Thours' )"
                                  v-on:blur.native="blurTimeField('Thours')">
                    </masked-input>
                    <!--<span>:</span>
                    <masked-input class="field-time_minute"
                                  v-model="serviceReport.time.to.minutes"
                                  mask="11" maxlength="2" placeholder="XX"
                                  v-on:keyup.native="changeTime( 'Tminutes' )"
                                  v-on:blur.native="blurTimeField('Tminutes')">
                    </masked-input>-->
                  </label>
                </div>
								<span class="report-time_title">
                  часов
                </span>
              </div>
              <div class="report-files"
                   v-bind:class="{ 'report-files__send' : serviceReport.send }">
                <div class="report-files_item report-files__pdf"
                     v-on:click="downloadFile('pdf')">
                  Скачать Сводный_отчет.pdf
                </div>
                <div class="report-files_item report-files__xlsx"
                     v-on:click="downloadFile('xlsx')">
                  Скачать Сводный_отчет.xlsx
                </div>
                <a href="" style="display: none" class="report-pdf"></a>
                <a href="" style="display: none" class="report-xlsx"></a>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
  import { CoolSelect } from 'vue-cool-select'
  import MaskedInput   from 'vue-masked-input';
  import { HTTP_AUTH, HTTP, HTTP_COMM, imgPath } from '@/main'
  import Datepicker from 'vuejs-datepicker';
  import {en, ru} from 'vuejs-datepicker/dist/locale'
  import ColorThief from 'colorthief'
  import { Chrome } from 'vue-color'

  export default {
    data : function () {
      return{
        manageStatus : 0, // 1 - Owner, 2 - Share, 3 - New
        activeCar : -1,
        timeZone : '',
        delCarType : 0,
        typeRegDevice: 0,
        password : {
          old_password  : "",
          new_password1 : "",
          new_password2 : ""
        },
        edit : {
          owner : {
            name : '',
            registration_id : '',
            registration_certificate_id : '',
            img : '',
            imgSrc : '',
						palette : []
          },
          share : {
            name : '',
            owner : {
              name : ''
            }
          },
          newCar : {
            serial : '',
            regkey : ''
          }
        },

        notifTO : {
          radio : 'val',
          id : 0,
          index : -1,
          odometer : 0,
          text : '',
          relevance : {},
          datepicker : {
            show : false,
            value: this.$moment()._d,
            lang : {
              ru : ru,
              en : en
            },
            parity : 0,
            disabledDates: {
              to: this.$moment().subtract(1, 'day')._d
            },
            error : {
              range : false
            },
            inputClass : 'datepickerField'
          },
        },

        serviceReport : {
          panel : 0,
          selectCars : [],
          time : {
            from : {
              hours : '00',
              minutes : '00'
            },
            to : {
              hours : '00',
              minutes : '00'
            }
          },
          send : false,
          datepicker : {
            show : false,
            value: '',
            lang : {
              ru : ru,
              en : en
            },
            parity : 0,
            disabledDates: {
              from: this.$moment().subtract(1, 'day')._d
            },
            error : {
              range : false
            },
            inputClass : 'datepickerField',
            highlighted: {
              dates: [],
            },
            formatDates : []
          },
        },

        datepicker : {
          birthDate: {
            show: false,
            value: '',
            lang: {
              ru: ru,
              en: en
            },
            disabledDates: {
              from: new Date()
            },
            inputClass: 'form-field'
          },
        },

				palette : {
          show : false,
          colors : {
            hex : '#194D33',
            rgba : { r : 0, g : 0, b : 0, a : 1 },
            hex8 : '#194D33FF',
            a: 1
					},
					field : '',
          updateValue : ''
				}
      }
    },
    computed : {
      user : function(){
        return this.$store.state.user
      },
      listCar(){
        return this.$store.state.cars.list;
      },
			currentCarIndex(){
        return this.$store.state.cars.current.index
			},
      stateCar(){
        return this.$store.state.cars.state
      },
      timeZoneVal(){
        return this.$store.state.timezone
      },

      fuelType : function () {
        return this.$store.state.fuel_type
      }
    },
    mounted : function () {
      setTimeout( () => {
        this.timeZone = this.user.data.time_zone.value;
      }, 400);

      for( let i = 0; i < this.listCar.length; i++ ){
        HTTP.get('/cars/' + this.listCar[i].id + '/reminder/maintenance/')
					.then( ( response ) => {
          	this.$set( this.notifTO.relevance, this.listCar[i].id, response.data);
					}).catch( () => {
          	this.notifTO.relevance[ this.listCar[i].id ] = null;
        	});
      }
    },
    methods : {
      // Редактирование авто владельца
      editOwner : function ( index ) {
        if( document.getElementsByClassName('ps ps--active-y')[0] ){
          document.getElementsByClassName('ps ps--active-y')[0].scrollTo(0, 0);
        }

        this.manageStatus = 1;
        this.activeCar = index;

				this.edit.owner.name 												 = this.listCar[ index ].name;
				this.edit.owner.registration_id 						 = this.listCar[ index ].registration_id;
				this.edit.owner.registration_certificate_id  = this.listCar[ index ].registration_certificate_id;
				this.edit.owner.img 												 = this.listCar[ index ].photo;

        setTimeout( () => {
          this.getColor();
				}, 100);
      },
      // Редактирование расшареного авто
      editShare : function ( index ) {
        if( document.getElementsByClassName('ps ps--active-y')[0] ){
          document.getElementsByClassName('ps ps--active-y')[0].scrollTo(0, 0);
        }

        this.manageStatus = 2;
        this.activeCar = index;

        this.edit.share = {
          name : this.listCar[ index ].name,
          owner : {
            name : this.listCar[ index ].owner.name
          }
        }
      },
      // Регистрация нового авто
      editRegistration : function () {
        this.manageStatus = 3;
      },

      // Сохранение данных владельца
      saveOwnerCar : function () {
        let formData = Object.assign({}, this.edit.owner);
        if( this.edit.owner.img ){
          formData.photo = this.edit.owner.img.replace(/\/\/media/g, '/media');
        }

        formData.vin = this.listCar[this.activeCar].vin;
        formData.fuel_tank_capacity = this.listCar[this.activeCar].fuel_tank_capacity;
        formData.fuel_type 	= this.listCar[this.activeCar].fuelType.val;

        formData.body_style = this.listCar[ this.activeCar ].body_style;

        let clr = this.palette.colors.rgba;
        formData.body_color = (clr.r << 16) | (clr.g << 8) | (clr.b);

        HTTP.put('cars/' + this.listCar[ this.activeCar ].id +'/', formData )
          .then( () => {
            this.$store.dispatch( 'addAlert', { text : 'Данные изменены', type : 'success' });

            HTTP.get('cars/')
              .then( ( response ) => {
                this.$store.dispatch('listCar', response.data);
              }).catch( ( error ) => {
                this.$store.dispatch('errorResponse', error );
              })
            ;
          }).catch( ( error ) => {
            this.$store.dispatch('errorResponse', error );
          })
        ;
      },
      // Сохранение данных расшаренного
      saveShareCar : function () {
        let _this = this;
        let formData = this.edit.share;

        HTTP.put('cars/' + this.listCar[ this.activeCar ].id +'/', formData )
          .then( function () {
            this.$store.dispatch( 'addAlert', { text : 'Данные изменены', type : 'success' });

            HTTP.get('cars/')
              .then( ( response ) => {
                this.$store.dispatch('listCar', response.data);
              }).catch( ( error ) => {
                this.$store.dispatch('errorResponse', error );
              })
            ;
        }).catch(function ( error ) {
          _this.$store.dispatch('errorResponse', error );
        });
      },
      // Добавление нового авто
      saveNewCar : function () {
        HTTP.post('cars/', this.edit.newCar ).then( () => {
          this.$store.dispatch( 'addAlert', { text : 'Авто добавлено', type : 'success' });
          this.edit.newCar.serial = '';
          this.edit.newCar.regkey = '';

          HTTP.get('cars/').then( response => {
            this.$store.dispatch('listCar', response.data);
          }).catch( error => {
            this.$store.dispatch('errorResponse', error );
          });
        }).catch( error => {
          this.$store.dispatch('errorResponse', error );
        });
      },

      // Загрузка изображения для авто владельца
      uploadImg : function () {
        let formData = new FormData();
        formData.set('file', this.$refs.photo.files[0] );

        HTTP.post('cars/' + this.listCar[this.activeCar].id + /photo/, formData)
					.then( response => {
						this.edit.owner.imgSrc = response.data.path;
						this.edit.owner.img = imgPath + response.data.path;

            setTimeout( () => {
              this.getColor();
            }, 100);
					}).catch( error => {
          	this.$store.dispatch('errorResponse', error );
        	});
      },
			getColor : function ( ) {
        let num = this.listCar[ this.activeCar ].body_color;
        console.log(num);

        this.$refs.chrome.colorChange({
          rgba : {
            a: 1,
            b: ( (num >> 0) & 0xFF),
            g: ( (num >> 8) & 0xFF),
            r: ( (num >> 16) & 0xFF)
          }
        });

        this.edit.owner.palette = ['#000000', '#FFFFFF'];

				let createPalette = () => {
          let palette = new ColorThief().getPalette( this.$refs.ownImg, 14, 5 );

          for( let i = 0; i < palette.length; i++ ){
            let p = palette[i];
            this.edit.owner.palette.push(
              '#' + [p[0], p[1], p[2]].map( x => {
                const hex = x.toString(16);
                return hex.length === 1 ? '0' + hex : hex
              }).join('')
            )
          }
        };

        if( this.edit.owner.img ){
          let img = new Image();
          img.onload = function() {
            createPalette();
          };
          img.src = this.$refs.ownImg.src;
        }
      },
      changeColorPalette : function( color ){
        this.$refs.chrome.colorChange({
          hex : color,
          a 	: 1
        });
			},
      checkOpenPalette : function( event ){
				if( this.palette.show && event.target.className !== "palette-choose_icon" && !event.target.closest('#paletteField') ){
          this.palette.show = false;
				}
			},

      // Сохранение данных пользователя
      saveUserData : function () {
        let userData =  Object.assign({}, this.user.data);
        userData.phone = '+' + userData.phone.replace(/\D/g, '');
        userData.time_zone = this.timeZone;

        HTTP_AUTH.put('user/', userData ).then( () => {
          this.$store.dispatch( 'addAlert', { text : 'Данные сохранены', type : 'success' });
        }).catch( error => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      // Изменение пароля
      changePassword : function () {
        let _this = this;
        HTTP_AUTH.post('password/change/', this.password ).then( function(){
          _this.$store.dispatch( 'addAlert', { text : 'Пароль изменен', type : 'success' });
          _this.password = {
            old_password  : "",
            new_password1 : "",
            new_password2 : ""
          }
        }).catch(function ( error ) {
          _this.$store.dispatch('errorResponse', error );
        });
      },

      // Выбрали машину оповещения ТО
      selectCarNotifTO : function ( index ) {
        this.notifTO.index = index;
        this.notifTO.id = 0;
        if( this.notifTO.relevance[this.listCar[index].id] ){
          this.notifTO.odometer = this.notifTO.relevance[this.listCar[index].id].odometer_threshold;
          this.notifTO.text = this.notifTO.relevance[this.listCar[index].id].text;
        }else{
          this.notifTO.odometer = this.stateCar[this.listCar[index].id].odometer.toFixed(0);
          this.notifTO.text = '';
        }
      },
      saveNotifTO : function () {
        let _this = this;
        if( this.notifTO.radio === 'val' ){
          if( this.notifTO.text.replace(/\s/g, '') !== '' ){
            if( this.notifTO.odometer !== '' ){
              HTTP.post('cars/' + this.listCar[this.notifTO.index].id + '/reminder/maintenance/', {
                "text": this.notifTO.text,
                "odometer_threshold": parseInt(this.notifTO.odometer),
              }).then(function ( response ) {
                _this.$store.dispatch( 'addAlert', { text : 'Оповещение добавлено', type : 'success' });

                if( !_this.notifTO.relevance[response.data.car] ){
                  _this.notifTO.relevance[response.data.car].odometer_threshold = response.data.odometer_threshold;
                  _this.notifTO.relevance[response.data.car].text               = response.data.text;
                  _this.notifTO.relevance[response.data.car].is_sent            = response.data.is_sent;
                  _this.notifTO.relevance[response.data.car].dt_threshold       = response.data.dt_threshold;
                }else{
                  _this.$set( _this.notifTO.relevance, response.data.id, response.data);
                }
              }).catch(function ( error ) {
                _this.$store.dispatch('errorResponse', error );
              });
            }else{
              this.$store.dispatch( 'addAlert', { text : 'Поле одометра должно быть заполнено', type : 'error' });
            }
          }else{
            this.$store.dispatch( 'addAlert', { text : 'Поле текста должно быть заполнено', type : 'error' });
          }
        }else{
          if( this.notifTO.text.replace(/\s/g, '') !== '' ){
            HTTP.post('cars/' + this.listCar[this.notifTO.index].id + '/reminder/maintenance/', {
              "text": this.notifTO.text,
              "dt_threshold": this.$moment(this.notifTO.datepicker.value).format('YYYY-MM-DD') + "T00:00:00",
            }).then(function ( response ) {
              _this.$store.dispatch( 'addAlert', { text : 'Оповещение добавлено', type : 'success' });

              _this.notifTO.relevance[response.data.car].odometer_threshold = response.data.odometer_threshold;
              _this.notifTO.relevance[response.data.car].text               = response.data.text;
              _this.notifTO.relevance[response.data.car].is_sent            = response.data.is_sent;
              _this.notifTO.relevance[response.data.car].dt_threshold       = response.data.dt_threshold;
            }).catch(function ( error ) {
              _this.$store.dispatch('errorResponse', error );
            });
          }else{
            this.$store.dispatch( 'addAlert', { text : 'Поле текста должно быть заполнено', type : 'error' });
          }
        }
      },

      // Тугл панели авто в отчетах
      toggleReportCar : function () {
        if( this.serviceReport.panel !== 1 ){
          this.serviceReport.panel = 1;
        }else{
          this.serviceReport.panel = 0;
        }
      },
      // Выбор автомобилей для отчетов
      selectReportCar : function ( index ) {
        if( this.listCar[index].access_report ){
          let relevanceItem = this.serviceReport.selectCars.indexOf( this.listCar[index].id );
          if( relevanceItem === -1 ){
            this.serviceReport.selectCars.push( this.listCar[index].id );
          }else{
            this.serviceReport.selectCars.splice( relevanceItem, 1 );
          }
        }
      },
      // Изменение панели отчетов
      changeReportType : function ( index ) {
        this.serviceReport.panel = index;
      },
      // Выбрали день в календаре отчетов
      selectDateReport : function ( event ) {
        let formatDate = this.$moment(event).format('YYYYMMDD');
        let relevanceItem = this.serviceReport.datepicker.formatDates.indexOf( formatDate );

        if( relevanceItem === -1 ){
          this.serviceReport.datepicker.formatDates.push( formatDate );
          this.serviceReport.datepicker.highlighted.dates.push( this.$moment(event)._d );
        }else{
          this.serviceReport.datepicker.formatDates.splice( relevanceItem, 1 );
          this.serviceReport.datepicker.highlighted.dates.splice( relevanceItem, 1 );
        }
      },
      // Скачать отчет
      downloadFile : function( fileType ){
        let _this = this;
        // Проверили выбраны ли машины
        if( this.serviceReport.selectCars.length > 0 ){
          // Указаны ли даты
          if( this.serviceReport.datepicker.highlighted.dates.length > 0 ){
            // Указано ли время
            if( this.serviceReport.time.from.hours !== '' &&
                this.serviceReport.time.from.minutes !== '' &&
                this.serviceReport.time.to.hours !== '' &&
                this.serviceReport.time.to.minutes !== '' ){

              // Собираем данные
              let dates = [],
                  hourFrom,
                  hourTo,
                  timesTo,
                  timesFrom,
                  highDates = this.serviceReport.datepicker.highlighted.dates,
                  disDayFrom = false,
                  disDayTo = false;

              // Время
              if( parseInt(this.serviceReport.time.from.hours) <= this.timeZoneVal/60*-1 ){ // от
                disDayFrom = true;
                hourFrom   = 24 + this.timeZoneVal/60 + parseInt(this.serviceReport.time.from.hours);
                if( hourFrom >= 24 ){ hourFrom = hourFrom - 24 }
              }else{
                hourFrom = parseInt(this.serviceReport.time.from.hours) + this.timeZoneVal/60;
              }
              if( hourFrom.toString().length === 1 ){ hourFrom = '0' + hourFrom }

              if( parseInt(this.serviceReport.time.to.hours) <= this.timeZoneVal/60*-1 ){ // до
                disDayTo = true;
                hourTo   = 24 + this.timeZoneVal/60 + parseInt(this.serviceReport.time.to.hours);
                if( hourTo >= 24 ){ hourTo = hourTo - 24 }
              }else{
                hourTo = parseInt(this.serviceReport.time.to.hours)   + this.timeZoneVal/60;
              }
              if( hourTo.toString().length === 1 ){ hourTo = '0' + hourTo }

              timesFrom = 'T' + hourFrom + ':' + this.serviceReport.time.from.minutes + ':00';
              timesTo   = 'T' + hourTo +   ':' + this.serviceReport.time.to.minutes +   ':00';

              // Даты timeZoneVal
              for( let i = 0; i < highDates.length; i++ ){
                let dtStart, dtStop;

                if( disDayFrom ){
                  dtStart = this.$moment(highDates[i]).subtract(1, "days").format('YYYY-MM-DD');
                }else{
                  dtStart = this.$moment(highDates[i]).format('YYYY-MM-DD');
                }

                if( disDayTo ){
                  dtStop = this.$moment(highDates[i]).subtract(1, "days").format('YYYY-MM-DD');
                }else{
                  dtStop = this.$moment(highDates[i]).format('YYYY-MM-DD');
                }

                dates.push({
                  "dt_start" : dtStart + timesFrom,
                  "dt_stop"  : dtStop + timesTo
                })
              }

              let link;
              if( this.serviceReport.panel === 2 ){
                link = '/report/v1/mileage/'
              }else if( this.serviceReport.panel === 3 ){
                link = '/report/v1/total/'
              }

              // включаем прелоадер
              this.serviceReport.send = true;

              HTTP_COMM({
                  method : 'post',
                  url: link,
                  responseType:'arraybuffer',
                  data : {
                    'cars'   : this.serviceReport.selectCars,
                    'dates'  : dates,
                    'format' : fileType
                  }
                }).then(function ( response ) {
                  let a,
                      blob;

                  if( fileType === 'pdf' ){
                    a = document.getElementsByClassName('report-pdf')[0];
                    blob = new Blob([response.data], { type: "application/pdf;charset=utf-8" } );
                    if( _this.serviceReport.panel === 2 ){
                      a.download = 'Отчет_пробег_за_период.pdf';
                    }else{
                      a.download = 'сводный_отчет.pdf';
                    }
                  }else{
                    a = document.getElementsByClassName('report-xlsx')[0];
                    blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" } );
                    if( _this.serviceReport.panel === 2 ){
                      a.download = 'Отчет_пробег_за_период.xlsx';
                    }else{
                      a.download = 'сводный_отчет.xlsx';
                    }
                  }

                  if( window.navigator && window.navigator.msSaveOrOpenBlob ){ //IE
                    window.navigator.msSaveOrOpenBlob(blob, a.download);
                  }
                  else{ // Not IE
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.click();
                    window.URL.revokeObjectURL(url);
                  }

                  // выключаем прелоадер
                  _this.serviceReport.send = false;
                }).catch(function ( error ) {
                  _this.serviceReport.send = false;
                  if( error.response.statusText === "Gateway Time-out" ){
                    _this.$store.dispatch( 'addAlert', { text : 'Превышено время ожидания ответа', type : 'error' });
                  }else{
                    _this.$store.dispatch( 'errorResponse', error );
                  }
              });
            }else{
              this.$store.dispatch( 'addAlert', { text : 'Не указано или неверно заполнено время отчета', type : 'error' });
            }
          }else{
            this.$store.dispatch( 'addAlert', { text : 'Не выбраны даты отчета', type : 'error' });
          }
        }else{
          this.$store.dispatch( 'addAlert', { text : 'Не выбрано ни одного авто', type : 'error' });
        }
        //('pdf')
      },

      // Изменили время
      changeTime : function( type ){
        if( type === 'Fhours' ){
          if( this.serviceReport.time.from.hours > 23 ){ this.serviceReport.time.from.hours = 23 }
        }else if( type === 'Fminutes' ){
          if( this.serviceReport.time.from.minutes > 59 ){ this.serviceReport.time.from.minutes = 59 }
        }else if( type === 'Thours' ){
          if( this.serviceReport.time.to.hours > 23 ){ this.serviceReport.time.to.hours = 23 }
        }else if( type === 'Tminutes'){
          if( this.serviceReport.time.to.minutes > 59 ){ this.serviceReport.to.minutes = 59 }
        }
      },
      // Проверяем правильность заполненного времени
      blurTimeField : function ( type ){
        if( type === 'Fhours' ){
          if( this.serviceReport.time.from.hours.toString().replace(/\D/g, '').length !== 2 ){ this.serviceReport.time.from.hours = '' }
        }else if( type === 'Fminutes' ){
          if( this.serviceReport.time.from.minutes.toString().replace(/\D/g, '').length !== 2 ){ this.serviceReport.time.from.minutes = '' }
        }else if( type === 'Thours' ){
          if( this.serviceReport.time.to.hours.toString().replace(/\D/g, '').length !== 2 ){ this.serviceReport.time.to.hours = '' }
        }else if( type === 'Tminutes'){
          if( this.serviceReport.time.to.minutes.toString().replace(/\D/g, '').length !== 2 ){ this.serviceReport.time.to.minutes = '' }
        }
      },

      // Удаление авто
      delCar : function () {
        let link = 'cars/' + this.listCar[this.activeCar].id +'/device/tie/';
        if( this.delCarType === 2 ){
          link = 'cars/' + this.listCar[this.activeCar].id +'/';
        }

        HTTP.delete( link ).then( () => {
          this.delCarType = 0;
          this.$store.dispatch( 'addAlert', { text : 'Автомобиль удален', type : 'success' });

          HTTP.get('cars/').then( (response) => {
            this.activeCar = -1;
            this.manageStatus = 0;

            this.$store.dispatch('listCar', response.data);
          }).catch( (error) => {
            this.$store.dispatch('errorResponse', error );
          });
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

      // Удаление шары
      delShare : function ( id, share_id ) {
        HTTP.delete( 'cars/' + id +'/shares/' + share_id + '/' )
          .then( () => {
            HTTP.get('cars/').then( (response) => {
              this.activeCar = -1;
              this.manageStatus = 0;

              this.$store.dispatch('listCar', response.data);
            }).catch( (error) => {
              this.$store.dispatch('errorResponse', error );
            });
          })
          .catch( (error) => {
            this.$store.dispatch('errorResponse', error );
          })
        ;
      },

      showPopup : function (){
        this.$store.dispatch('mainPopup');
      },

      // Подтверждение email
      sendConfirm : function () {
        HTTP_AUTH.post('registration/token/', {
        }).then((data) => {
          HTTP_AUTH.defaults.headers.common['X-Registration-Token'] = data.data.token;

          HTTP_AUTH.post('registration/resend-verification/', {
              email     : this.user.data.email
            })
            .then( response => {
              this.$store.dispatch( 'addAlert', { text : response.data.detail, type : 'success' });
              delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
            })
            .catch( error => {
              this.$store.dispatch('errorResponse', error );
              delete HTTP_AUTH.defaults.headers.common['X-Registration-Token'];
            });
        }).catch((error) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

			//
      logout : function () {
        HTTP_AUTH.post('logout/').then(() => {
          document.cookie = 'userToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
          setTimeout(function () {
            window.location.reload();
          }, 100)
        }).catch( (error) => {
          this.$store.dispatch('errorResponse', error );
        });
      },

      openDatapickerBirthdate : function(){
        this.datepicker.birthDate.show = true;
      },
      closeDatapickerBirthdate : function(){
        this.datepicker.birthDate.show = false;
      },
      datepickerFormatterBirthDate : function ( date ) {
        this.user.data.birth_date = this.$moment( date ).format('YYYY-MM-DD');
        this.datepicker.birthDate.show = false;
      },

      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
    },
    components : {
      MaskedInput,
      CoolSelect,
      Datepicker,
			Chrome
    }
  }
</script>